/* eslint-disable  */

import { APIClient } from "./_api";
const endpoint = "/ReferralBounce";

export function getAll(query) {
  return APIClient.get(
    `${endpoint}/myReferral${query?.sort ? `?sort=${query?.sort}` : ""}${
      query?.parentId ? `&parentId=${query?.parentId}` : ""
    }`
  );
}

export function getAllAdmin(query) {
  return APIClient.get(
    `${endpoint}/total${query?.sort ? `?sort=${query?.sort}` : ""}${
      query?.parentId ? `&parentId=${query?.parentId}` : ""
    }`
  );
}
export function getAllCheck(query) {
  return APIClient.post(`/Referrals/check/users`);
}

export function changeSeller(data) {
  return APIClient.post(`/Referrals/change/seller`, data);
}

export function payReferralBounce({ data }) {
  return APIClient.put(`${endpoint}/pay/${data.id}`, {
    reference: data.values,
  });
}

export function getAllAdminOrderPaid(id) {
  return APIClient.get(`${endpoint}/total/${id}`);
}
